var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedsJobCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "9px",
    viewBox: "0 0 13 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Housing-Results",
    transform: "translate(-123.000000, -154.000000)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(123.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.625,8.49193548 C1.625,8.77318548 1.39930556,9 1.11944444,9 L0.505555556,9 C0.225694444,9 0,8.77318548 0,8.49193548 L0,0.508064516 C0,0.226814516 0.225694444,0 0.505555556,0 L1.11944444,0 C1.39930556,0 1.625,0.226814516 1.625,0.508064516 L1.625,8.49193548 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875,6.06988636 C12.1875,6.33409091 11.9733622,6.54545455 11.7078313,6.54545455 L1.29216867,6.54545455 C1.0266378,6.54545455 0.8125,6.33238636 0.8125,6.06988636 L0.8125,4.56988636 C0.8125,4.30568182 1.0266378,4.09090909 1.29216867,4.09090909 L11.7078313,4.09090909 C11.9733622,4.09090909 12.1875,4.30568182 12.1875,4.56988636 L12.1875,6.06988636 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,8.50197628 C13,8.77766798 12.7743056,9 12.4944444,9 L11.8805556,9 C11.6006944,9 11.375,8.77766798 11.375,8.50197628 L11.375,4.58893281 C11.375,4.31324111 11.6006944,4.09090909 11.8805556,4.09090909 L12.4944444,4.09090909 C12.7743056,4.09090909 13,4.31324111 13,4.58893281 L13,8.50197628 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875,3.5474026 C4.875,3.84935065 4.68921494,4.09090909 4.45884146,4.09090909 L2.85365854,4.09090909 C2.62328506,4.09090909 2.4375,3.8474026 2.4375,3.5474026 L2.4375,3.00194805 C2.4375,2.7 2.62328506,2.45454545 2.85365854,2.45454545 L4.45884146,2.45454545 C4.68921494,2.45454545 4.875,2.7 4.875,3.00194805 L4.875,3.5474026 Z",
    id: "Fill-7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedsJobCard);
export default __webpack_public_path__ + "static/media/bedsJobCard.6f496aa4.svg";
export { ForwardRef as ReactComponent };